import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { TruthSection } from '../components/TruthSection';
import { ProductIntro } from '../components/ProductIntro';
import { MechanismSection } from '../components/MechanismSection';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoForSection } from '../components/WhoForSection';
import { TransformSection } from '../components/TransformSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen w-full bg-deep" data-id="element-541">
      <HeroSection data-id="element-542" />
      <ProblemSection data-id="element-543" />
      <TruthSection data-id="element-544" />
      <ProductIntro data-id="element-545" />
      <MechanismSection data-id="element-546" />
      <WhyFailedSection data-id="element-547" />
      <WhatYouGetSection data-id="element-548" />
      <WhoForSection data-id="element-549" />
      <TransformSection data-id="element-550" />
      <PricingCTA data-id="element-551" />
      <Footer data-id="element-552" />
    </div>;
}